import { Path } from "react-native-svg";
import { createIcon } from "../Icon";

export const ChargeUltraV2Icon = createIcon({
	viewBox: "0 0 24 24",
	path: (
		<>
			<Path
				stroke="transparent"
				d="M10.7587 20.9249C9.7988 20.3334 11.0117 17.1909 11.366 15.0541C11.5726 13.8079 8.90101 14.6202 8.14549 14.3858C6.37879 13.8379 8.2 10.7417 11.4854 7.30426C14.7713 3.86682 16.436 2.67684 17.6015 3.07313C18.7664 3.46997 17.3922 7.17998 16.883 9.8243C16.6306 11.1331 19.5039 10.2211 20.2322 10.5515C21.3 11.0361 21.2259 12.3558 17.0744 16.8262C12.9228 21.2966 11.4777 21.3675 10.7593 20.9249"
			/>
			<Path
				stroke="transparent"
				d="M23.2641 5.42574H22.3026V4.46417C22.3026 4.05752 21.9733 3.72827 21.5667 3.72827C21.16 3.72827 20.8308 4.05806 20.8308 4.46417V5.42574H19.8692C19.4631 5.42574 19.1333 5.75498 19.1333 6.16163C19.1333 6.56828 19.4625 6.89753 19.8692 6.89753H20.8308V7.8591C20.8308 8.2652 21.16 8.595 21.5667 8.595C21.9733 8.595 22.3026 8.26575 22.3026 7.8591V6.89753H23.2641C23.6708 6.89753 24 6.56774 24 6.16163C24 5.75553 23.6708 5.42574 23.2641 5.42574Z"
			/>
			<Path
				stroke="transparent"
				d="M7.48378 10.0919H0.817662C0.366312 10.0919 0 9.72555 0 9.2742C0 8.82286 0.366312 8.45654 0.817662 8.45654H7.48378C7.93513 8.45654 8.30145 8.82286 8.30145 9.2742C8.30145 9.72555 7.93513 10.0919 7.48378 10.0919Z"
			/>
			<Path
				stroke="transparent"
				d="M5.68433 13.4776H2.48673C2.03538 13.4776 1.66907 13.1113 1.66907 12.6599C1.66907 12.2086 2.03538 11.8423 2.48673 11.8423H5.68433C6.13568 11.8423 6.50199 12.2086 6.50199 12.6599C6.50199 13.1113 6.13568 13.4776 5.68433 13.4776Z"
			/>
			<Path
				stroke="transparent"
				d="M9.93675 6.70686H4.23002C3.77867 6.70686 3.41235 6.34054 3.41235 5.88919C3.41235 5.43785 3.77867 5.07153 4.23002 5.07153H9.93675C10.3881 5.07153 10.7544 5.43785 10.7544 5.88919C10.7544 6.34054 10.3881 6.70686 9.93675 6.70686Z"
			/>
		</>
	),
});
